<template>
  <div>
    <el-container>
      <el-header height="130px">
        <headCom></headCom>
      </el-header>
      <el-main>
        <div id="content_div" class="myClass">
          <themeList></themeList>
        </div>
      </el-main>
      <el-footer height="30px">
        <footCom></footCom>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
// import head from '@/components/public/head_shopCard.vue'
import head from '@/components/public/head_searchbox'
import foot from '@/components/public/footer.vue'
import themeList from '@/components/feedback/mainPostList.vue'

export default {
  data () {
    return {
      showPageName: 'shoppingCartSelectPage', // 默认进入模板选择页面
      emitShoppingCartId: 0,
      emitPayTypeStr: '',
      emitPaySumMoney: null,
      emitPayTypeCheckIntervalAddress: null,
      reCheckUnpaiedStatePropertie: false
    }
  },
  components: {
    headCom: head, // 统一抬头栏
    footCom: foot, // 统一页面下方提示信息
    themeList: themeList // 主题列表
  }
}
</script>

<style scoped>
.myClass {
  color: #fff;
  font-size: 20px;
}
#content_div {
  width: -webkit-calc(100%);
  width: -moz-calc(100%);
  width: calc(100%);
  height: -webkit-calc(100vh - 195px);
  height: -moz-calc(100vh - 195px);
  height: calc(100vh - 195px);
  margin-left: auto;
  margin-right: auto;
}
.el-header {
  color: #333;
  text-align: center;
  padding-top: 10px;
}
.el-footer {
  color: #333;
  text-align: center;
}

.el-aside {
  color: #333;
  text-align: center;
  line-height: 200px;
}

.el-main {
  color: #333;
  text-align: center;
  overflow: hidden;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

#backStep {
  height: 100px;
  box-sizing: border-box;
  -moz-box-sizing: border-box; /* Firefox */
  -webkit-box-sizing: border-box; /* Safari */
  padding-top: 60px;
}
</style>
